import TriggerSerializer from 'eflex/serializers/trigger';

export default class TurckIoTriggerSerializer extends TriggerSerializer {}
